import { render, staticRenderFns } from "./default.vue?vue&type=template&id=18ddbe53"
import script from "./default.vue?vue&type=script&lang=ts"
export * from "./default.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserAccRemovingModal: require('/builds/project/wyffest/frontend/components/user/AccRemovingModal.vue').default,AppDialog: require('/builds/project/wyffest/frontend/components/app/AppDialog.vue').default,AppLayout: require('/builds/project/wyffest/frontend/components/app/AppLayout.vue').default})
